export const GET_NOTICE_MANAGE                  = 'GET_NOTICE_MANAGE';
export const DEL_NOTICE_MANAGE                  = 'DEL_NOTICE_MANAGE';
export const SAVE_NOTICE_MANAGE                 = 'SAVE_NOTICE_MANAGE';
export const RESET_FORM_SAVE_RESPONSE           = 'RESET_FORM_SAVE_RESPONSE';